import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useCompanionStakingPool from './useCompanionStakingPool';

const useStakedCompanions = () => {
  const { account } = useWeb3React();
  const stakingPool = useCompanionStakingPool();

  const [stakedCompanions, setStakedCompanions] = useState([]);

  useEffect(() => {
    let ignore = false;
    setStakedCompanions([]);
    if (stakingPool) {
      const fetchStakedCompanions = () => {
        stakingPool.stakedTokens(account).then((tokenIds) => {
          if (!ignore)
            setStakedCompanions(tokenIds.map((tokenId) => tokenId.toNumber()));
        });
      };
      fetchStakedCompanions();
      const stake = stakingPool.filters.Stake(account);
      const unstake = stakingPool.filters.Unstake(account);

      stakingPool.on(stake, fetchStakedCompanions);
      stakingPool.on(unstake, fetchStakedCompanions);

      return () => {
        stakingPool.off(stake, fetchStakedCompanions);
        stakingPool.off(unstake, fetchStakedCompanions);
        ignore = false;
      };
    }
  }, [stakingPool, account]);

  return stakedCompanions;
};

export default useStakedCompanions;
